import { Location as LocationType } from '../../types/Artist';

export const isNumeric = (input: string) => {    
    return !isNaN(+input);  
}

export const format = (artistName: string): string => {
    if (artistName === undefined) {
        return '';
    }
    
    // Harley, Steve & Cockney Rebel
    const ampSplit = artistName.split(' & ');
    const hasAmp = ampSplit.length > 1;
    const ampName = hasAmp ? ampSplit[0] : artistName;
    const commaSplit = ampName.split(', ');
    
    // Steve & Cockney Rebel Harley
    const name = commaSplit.length > 1 
        ? `${commaSplit[1]} ${commaSplit[0]}`
        : ampName;

    return hasAmp ? `${name} & ${ampSplit[1]}` : name;
}

export const splitAlbumName = (albumName: string): { year: string, title: string } => {
    const index = albumName.indexOf(' - ');
    const year = albumName.substring(0, index);
    const title = albumName.substring(index + 3).trim();
    return { year, title }
}

export const getLetter = (artistName: string) => {
    const firstCharacter = artistName.substring(0, 1);
    return isNumeric(firstCharacter) ? '0 - 9' : firstCharacter.toUpperCase();
}

export const trackDuration = (duration: number | undefined) => {
    if (duration) {
        const hourResult = duration / 1000 / 60 / 60;
        if (hourResult > 1)
        {
            const hours = Math.floor(hourResult);
            const minuteResult = (hourResult - hours) * 60;
            const minutes = Math.floor(minuteResult);
            const seconds = Math.floor((minuteResult - minutes) * 60);
            return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        }
         
        const minuteResult = duration / 1000 / 60;
        const minutes = Math.floor(minuteResult);
        const seconds = Math.floor((minuteResult - minutes) * 60);
        return `${minutes}:${String(seconds).padStart(2, '0')}`;
    }

    return '';
}

export const getLocationString = (location: LocationType): string => {
    const items: string[]  =  [];

    if (location == null) {
        return '';
    }

    if (location.city && location.city !== '-') {
        items.push(location.city);
    }

    if (location.stateProvidence && location.stateProvidence !== '-') {
        items.push(location.stateProvidence);
    }

    if (location.country) {
        items.push(location.country);
    }
    
    return items.join(', ');
}

export const getLocationLink = (location: LocationType): string => {
    if (location == null) {
        return '';
    }

    let link = `/locations/country/${location?.country}`;
    if (location.stateProvidence || location.city) {
        link += `/stateProvidence/`;
        if (location.stateProvidence) {
            link += `${location.stateProvidence}`;
        } else {
            link += `-`;
        }

        if (location.city) {
            link += `/city/${location.city}`;
        }
    }

    return link;
}

export const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');